import CookieService from "./CookieService";
import uuidv1 from "uuid";
import makeAjaxRequest from "./makeAjaxRequest";
import fetchUrl from "./fetchUrl";
import { getCookieDomain } from "./utils";

const saveRST = () => {
  return new Promise((resolve, reject) => {
    const urlParams = new URLSearchParams(window.location.search);

    let utm_source = urlParams.get("utm_source") || "";
    let utm_medium = urlParams.get("utm_medium") || "";
    const utm_campaign = urlParams.get("utm_campaign") || "";
    const utm_content = urlParams.get("utm_content") || "";
    const utm_term = urlParams.get("utm_term") || "";
    const gclid = urlParams.get("gclid") || "";
    const fbclid = urlParams.get("fbclid") || "";

    const userAgent = window.navigator.userAgent
      ? window.navigator.userAgent
      : "Unknown userAgent";

    const extraInfo = JSON.stringify({
      userAgent,
      path: window.location.href
    });

    const old_utm_source = CookieService.getCookie("utm_source") || "";
    const old_utm_medium = CookieService.getCookie("utm_medium") || "";
    const old_utm_campaign = CookieService.getCookie("utm_campaign") || "";
    const old_utm_content = CookieService.getCookie("utm_content") || "";
    const old_utm_term = CookieService.getCookie("utm_term") || "";
    const isRstSaved = CookieService.getCookie("isRstSaved") || "";
    const old_document_referrer = CookieService.getCookie("referrer") || "";
    const isSessionRunning = CookieService.getCookie("isSessionRunning") || "";

    let isMarkAPIAllow =
      old_utm_source.toString() !== utm_source.toString() ||
      old_utm_medium.toString() !== utm_medium.toString() ||
      old_utm_campaign.toString() !== utm_campaign.toString() ||
      old_utm_content.toString() !== utm_content.toString() ||
      old_utm_term.toString() !== utm_term.toString() ||
      !isRstSaved;
    let callMarkDevice = false;

    if (!isRstSaved) {
      CookieService.setCookie("isRstSaved", true, 365);
      callMarkDevice = true;
    }

    const utmData = {};
    const referrerList = ["google", "bing", "duckduckgo", "yahoo"];

    const referrerMap = {
      google: {
        utm_source: "google",
        utm_medium: "organic"
      },
      bing: {
        utm_source: "bing",
        utm_medium: "organic"
      },
      duckduckgo: {
        utm_source: "duckduckgo",
        utm_medium: "organic"
      },
      yahoo: {
        utm_source: "yahoo",
        utm_medium: "organic"
      }
    };

    /*
    We are finding the referrer and then matching it with referrerList
    if we find a match then we check if it exists inside the referrerMap
    if it exists and there are no utm params available in the URL
    we change the source and medium acc to the map
    and call the ust api if all the other old conditions are met. 
    we are anyway sending referrer in the ust api as an info.
    Detailed explanation can be found here:
    https://infoedge.atlassian.net/wiki/spaces/JH/pages/2513731681/Referrer+and+forwarding+Query+parameters+for+Redirections.
    */

    const referrer = document.referrer || "";
    const referrerKey = referrerList.filter(url => referrer.includes(url));
    const validReferrer = !!(referrerKey.length && referrerMap[referrerKey[0]]);
    if (
      !gclid &&
      !fbclid &&
      !utm_source &&
      !utm_medium &&
      validReferrer &&
      !isSessionRunning
    ) {
      utm_source = referrerMap[referrerKey[0]].utm_source;
      utm_medium = referrerMap[referrerKey[0]].utm_medium;
      isMarkAPIAllow = true;
    }

    if (utm_source) {
      utmData.utm_source = utm_source.toString();
    }

    if (utm_medium) {
      utmData.utm_medium = utm_medium.toString();
    }

    if (utm_campaign) {
      utmData.utm_campaign = utm_campaign.toString();
    }

    if (utm_content) {
      utmData.utm_content = utm_content.toString();
    }

    if (utm_term) {
      utmData.utm_term = utm_term.toString();
    }

    if (validReferrer) {
      utmData.referrer = referrer.toString();
    }

    if (utm_source && old_utm_source.toString() !== utm_source.toString()) {
      CookieService.setCookie("utm_source", utm_source, 30);
      callMarkDevice = true;
    }

    if (utm_medium && old_utm_medium.toString() !== utm_medium.toString()) {
      CookieService.setCookie("utm_medium", utm_medium, 30);
      callMarkDevice = true;
    }

    if (
      utm_campaign &&
      old_utm_campaign.toString() !== utm_campaign.toString()
    ) {
      CookieService.setCookie("utm_campaign", utm_campaign, 30);
      callMarkDevice = true;
    }

    if (utm_content && old_utm_content.toString() !== utm_content.toString()) {
      CookieService.setCookie("utm_content", utm_content, 30);
      callMarkDevice = true;
    }

    if (utm_term && old_utm_term.toString() !== utm_term.toString()) {
      CookieService.setCookie("utm_term", utm_term, 30);
      callMarkDevice = true;
    }
    if (
      validReferrer &&
      old_document_referrer.toString() !== referrer.toString()
    ) {
      CookieService.setCookie("referrer", referrer, 30);
    }

    if (!isSessionRunning) {
      CookieService.setCookie("isSessionRunning", true, 30 / (60 * 24));
    }

    if (isMarkAPIAllow) {
      if (callMarkDevice)
        makeAjaxRequest({
          method: "POST_NO_AUTH",
          url: fetchUrl("devices", "rst"),
          data: {
            rstData: utmData,
            request_info: extraInfo,
            userAgent,
            caller: "client"
          }
        })
          .then(() => {
            resolve();
          })
          .catch(err => {
            reject();
          });
    } else {
      resolve();
    }
  });

  /* End Save UST */
};
export const createDeviceIdClient = () => {
  let deviceId = CookieService.getCookie("recDeviceId");

  if (!deviceId) {
    deviceId = uuidv1();
    const cookieDomain = getCookieDomain();
    CookieService.setCookie("recDeviceId", deviceId, 365, cookieDomain);
    const url = fetchUrl("devices/v2", "recruiter-mark-device");
    const body = { deviceId };

    makeAjaxRequest({
      method: "POST",
      url,
      data: body,
      withAuth: true
    });
    saveRST().then(() => {
      callVerify(deviceId);
    });
  } else {
    saveRST().then(() => {
      callVerify(deviceId);
    });
  }
};

const callVerify = deviceId => {
  const verified = CookieService.getCookie("recdeviceIdVerified");
  const url = `${process.env.REC_URL}/v1/deviceid/verify`;

  if (!verified)
    makeAjaxRequest({
      method: "POST",
      url
    })
      .then(() => {
        const cookieDomain = getCookieDomain();
        CookieService.setCookie(
          "recdeviceIdVerified",
          "true",
          365,
          cookieDomain
        );
      })
      .catch(() => {});
};
